module.exports = __webpack_public_path__ + "media/images/logo-0ea669c4a03a080c23c418d8be34cc85.svg";